module.exports = __webpack_public_path__ + "static/img/4.dcdfb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/price/4.png
// module id = L1Xk
// module chunks = 1